module.exports = __webpack_public_path__ + "img/75.6fe780e5.jpg";